import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    GetContactAudiences as GetContactAudiencesQuery,
    GetContactAudiencesVariables,
    GetContactAudiences_contact_audienceMembershipsSubscribed as Audience,
    GetContactAudiences_contact as Contact,
} from 'nutshell-graphql-types';

import GET_CONTACT_AUDIENCES from '../queries/get-contact-audiences.graphql';

export const useGetContactAudiences = (
    contactId: string
): {
    audiences: Audience[] | null | undefined;
    contact: Contact | null | undefined;
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch, networkStatus} = useQuery<
        GetContactAudiencesQuery,
        GetContactAudiencesVariables
    >(GET_CONTACT_AUDIENCES, {
        variables: {
            personId: contactId,
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        audiences: data && data.contact && data.contact.audienceMembershipsSubscribed,
        contact: data && data.contact,
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
